import * as React from "react";
import Link from "@mui/material/Link";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import useMediaQuery from "@mui/material/useMediaQuery";
import SegmentIcon from '@mui/icons-material/Segment';
import { Button, Container, Stack, IconButton } from "@mui/material";

import Logo from "../components/Logo";
// import { ReactComponent as MenuIcon } from '../assets/images/menu.svg';
import { ReactComponent as HomeIcon } from '../assets/images/cottage.svg';
import { ReactComponent as TokenNomicsIcon } from '../assets/images/database.svg';
import { ReactComponent as RoadMapIcon } from '../assets/images/lan.svg';
import { ReactComponent as WhiteIcon } from '../assets/images/note.svg';
import { ReactComponent as ProjectsIcon } from '../assets/images/domain_verification.svg';
import { ReactComponent as ServicesIcon } from '../assets/images/compass_calibration.svg';

const Header = () => {
  const ismobile = !useMediaQuery('(min-width:800px)');
  const [on, setOn] = React.useState(null);
  const open = Boolean(on);

  const handleClick = (event: any) => {
    setOn(event.currentTarget);
  };
  const handleClose = () => {
    setOn(null);
  };

  return (
    <Container sx={{ maxWidth: '1300px !important', px: '0px !important' }}>
      {
        ismobile ? (
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems='center'
            p={2}
          >
            <Stack><Logo maxWidth="140px" /></Stack>
            <IconButton
              onClick={handleClick}
              aria-label="menu"
              sx={{ color: 'white', width: 'fit-content' }}
            >
              <SegmentIcon fontSize="large" />
            </IconButton>
          </Stack>
        ) : (
          <Stack
            direction="row"
            justifyContent="space-between"
            sx={{
              my: 2.5,
              '& button': {
                fontWeight: 700,
                fontSize: 16,
                color: 'white',
                px: '10px',
                letterSpacing: '-0.03em',
                '&:hover': {
                  background: 'transparent',
                  color: '#7357EA',
                  '& path': {
                    fill: '#7357EA'
                  }
                },
                '& path': {
                  fill: '#74748f',
                  transition: '.3s',
                }
              }
            }}
          >
            <Stack direction="row" spacing={5}>
              <Link href='#'><Button startIcon={<HomeIcon />} disableRipple>Home</Button></Link>
              <Link href='#projects'><Button startIcon={<ProjectsIcon />} disableRipple>Projects</Button></Link>
              <Link href='#tokenomics'><Button startIcon={<TokenNomicsIcon />} disableRipple>Tokenomics</Button></Link>
            </Stack>
            <Stack><Logo /></Stack>
            <Stack direction="row" spacing={5}>
              <Link href='#services'><Button startIcon={<ServicesIcon />} disableRipple>Services</Button></Link>
              <Link href='#roadmap'><Button startIcon={<RoadMapIcon />} disableRipple>Roadmap</Button></Link>
              <Link href='https://2xlucky.gitbook.io/whitepaper/' target='_blank' >
                <Button startIcon={<WhiteIcon />} disableRipple>Whitepaper</Button>
              </Link>
            </Stack>
          </Stack>
        )
      }
      <Menu
        anchorEl={on}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            background: '#171844',
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            ml: 0.2,
            '& .MuiButtonBase-root': {
              fontWeight: 700,
              fontSize: 16,
              color: 'white',
              '&:hover': {
                color: '#7357EA',
                '& path': {
                  fill: '#7357EA'
                }
              },
              '& path': {
                fill: '#74748f',
                transition: '.3s',
              }
            }
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <Link href='#'><MenuItem><ListItemIcon><HomeIcon /></ListItemIcon>Home</MenuItem></Link>
        <Link href='#projects'><MenuItem><ListItemIcon><ProjectsIcon /></ListItemIcon>Projects</MenuItem></Link>
        <Link href='#tokenomics'><MenuItem><ListItemIcon><TokenNomicsIcon /></ListItemIcon>Tokenomics</MenuItem></Link>
        <Link href='#services'><MenuItem><ListItemIcon><ServicesIcon /></ListItemIcon>Services</MenuItem></Link>
        <Link href='#roadmap'><MenuItem><ListItemIcon><RoadMapIcon /></ListItemIcon>Roadmap</MenuItem></Link>
        <Link href='https://2xlucky.gitbook.io/whitepaper/' target='_blank' >
          <MenuItem>
            <ListItemIcon>
              <WhiteIcon />
            </ListItemIcon>
            Whitepaper
          </MenuItem>
        </Link>
      </Menu>
    </Container>
  );
};

export default Header;
